import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import { Card, Grid, Icon } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Authentication layout components
import PageLayout from "examples/LayoutContainers/PageLayout";

// Images
import logo from "assets/images/logos/laddar_logo_long.png";
import usePageTitle from "app/pageTitle";
import SERVICES from "../service_config";

const SERVICE_STORAGE_KEY = "laddar_service";

// const SERVICES = [
//   {
//     id: "field_os",
//     name: "Field OS",
//     icon: "workspaces",
//     path: "/field-os",
//     description: "Manage your field teams, activities and operations.",
//   },
//   {
//     id: "voice",
//     name: "Voice",
//     icon: "dialer_sip",
//     path: "/voice-os",
//     description: "Manage business calls, call centers and call analytics.",
//   },
// ];

function LaddarOSPage() {
  const pageTitle = "Laddar OS - Select Workspace";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    const storedService = localStorage.getItem(SERVICE_STORAGE_KEY);

    if (storedService) {
      setSelectedService(storedService);
    }
  }, []);

  const selectService = (service) => {
    setSelectedService(service.id);
    localStorage.setItem(SERVICE_STORAGE_KEY, service.id);
    // navigate(service.path);
    window.location.href = service.path;
  };

  return (
    <PageLayout>
      <MDBox
        minHeight="100vh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        px={{ xs: 2, sm: 3, md: 5 }}
        py={{ xs: 3, md: 4 }}
      >
        {/* Logo */}
        <MDBox align="center" mb={2}>
          <img src={logo} alt="Laddar" width={145} />
        </MDBox>

        {/* Header */}
        <MDBox align="center" mb={{ xs: 3, md: 4 }}>
          {/* <MDTypography
            variant="h4"
            fontWeight="medium"
            sx={{
              fontSize: {
                xs: "1.5rem",
                md: "1.75rem",
              },
            }}
          >
            What would you like to work on?
          </MDTypography> */}

          <MDTypography
            variant="body2"
            color="text"
            fontWeight="regular"
            sx={{
              maxWidth: 600,
              mx: "auto",
            }}
          >
            Choose a workspace, you can switch between workspaces at any time.
          </MDTypography>
        </MDBox>

        {/* Services */}
        <MDBox maxWidth="1100px" width="100%" mx="auto">
          <Grid container spacing={{ xs: 2, md: 2.5 }} justifyContent="center">
            {SERVICES.map((service) => {
              const isSelected = selectedService === service.id;

              return (
                <Grid item xs={12} sm={6} md={4} key={service.id}>
                  <Card
                    onClick={() => selectService(service)}
                    sx={{
                      height: "100%",
                      cursor: "pointer",
                      border: "1px solid",
                      borderColor: isSelected ? "dark.main" : "transparent",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        transform: "translateY(-3px)",
                        boxShadow: 5,
                      },
                    }}
                  >
                    <MDBox
                      p={{ xs: 2.5, md: 3 }}
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      textAlign="center"
                      height="100%"
                    >
                      {/* Icon */}
                      <MDBox
                        width={52}
                        height={52}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="50%"
                        bgColor="grey-100"
                        mb={1.5}
                      >
                        <Icon
                          sx={{
                            fontSize: 27,
                            color: "dark.main",
                          }}
                        >
                          {service.icon}
                        </Icon>
                      </MDBox>

                      {/* Service name */}
                      <MDTypography variant="h6" fontWeight="medium">
                        {service.name}
                      </MDTypography>

                      {/* Description */}
                      <MDTypography
                        mt={1}
                        variant="body2"
                        color="text"
                        fontWeight="regular"
                        lineHeight={1.6}
                        sx={{
                          maxWidth: 290,
                        }}
                      >
                        {service.description}
                      </MDTypography>

                      {/* Action */}
                      <MDBox mt={2.5}>
                        <MDButton
                          variant="contained"
                          color="dark"
                          size="small"
                          endIcon={<Icon>east</Icon>}
                          onClick={(event) => {
                            event.stopPropagation();
                            selectService(service);
                          }}
                        >
                          Open
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </MDBox>

        {/* Footer */}
        <MDBox align="center" mt={4}>
          <MDTypography variant="caption" color="text">
            Your workspace determines the tools and navigation available to you.
          </MDTypography>
        </MDBox>
      </MDBox>
    </PageLayout>
  );
}

export default LaddarOSPage;
